<template>
    <div class="new-home-avantage-section">
        <p class="discover">
            Découvrez vos avantages membre
            <span class="arrow-down"></span>
        </p>

        <ul>
            <li
                v-for="(item, index) in avantage"
                :key="index"
                class="text-uppercase categories"
            >
                <a
                    :href="'#' + removeSpace(item.name)"
                >
                    {{ item.categorie }}
                </a>
            </li>
        </ul>
        <NewHomeAvantageDesktop :avantage="avantage"/>
        <NewHomeAvantageAccordion :avantage="avantage"/>
        <div class="start-pack">
            <p class="text-uppercase">Offre réservée aux nouveaux membres</p>
            <h2>Découvrez Testachats<br/>pendant 2 mois <br> <span class="orange-text"> pour 2 €</span></h2>
            <h5>
                Et choisissez votre cadeau de bienvenue parmi des dizaines de marques
            </h5>
            <div class="gifts-dropdown avantages">
                <GiftForm is_dropdown />
                <b-button class="button is-primary next-button" @click="nextStep()"
                          :disabled="!selectedGiftId"
                >
                    Demander votre pack
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
import NewHomeAvantageAccordion from "../_commons/fr/newComponents/NewHomeAvantageAccordion";
import NewHomeAvantageDesktop from "../_commons/fr/newComponents/NewHomeAvantageDesktop";
import GiftForm from "../../components/form/steps/library/fr/giftchoice/GiftForm";
import mixin from "../../components/form/steps/travel_step_mixin";
import image_mixin from "../_commons/fr/mixins/image_mixin";
import {sync} from "vuex-pathify";


export default {
    mixins: [mixin, image_mixin],
    components: {
        NewHomeAvantageAccordion,
        NewHomeAvantageDesktop,
        GiftForm
    },
    computed: {
        avantage() {
            return [
                {
                    categorie: `${this.economy_amount} € d’économies`,
                    name: "économies",
                    title: `Jusqu’à ${this.economy_amount} € d'économies par an*`,
                    description: `Votre facture d'acompte de gaz et d'électricité pèse lourdement sur le budget familial ? Peut-être est-ce l'occasion de faire le point sur tous vos frais : supermarché, voiture, assurances, télécoms... Avec nos conseils, vous pouvez économiser jusqu'à ${this.economy_amount}€* chaque année. <br><br>
      <span class="text-asterix">*prix moyen basé sur une étude annuelle.</span>`,
                    img: "/images/fr_new_home/avantage-image/img_1_avantage.png",
                },
                {
                    categorie: "members club",

                    name: "Members Club",
                    title: `Profitez de réductions exclusives`,
                    description: `Profitez de réductions exclusives En tant que membre de Testachats, profitez de réductions allant jusqu’à 70% sur les produits qui vous intéressent chez plus de 100 partenaires. Que ce soit pour la maison, pour faire du shopping, pour vos vacances ou pour votre voiture, faites le plein d’offres exceptionnelles dans vos commerces de proximité ou grandes enseignes. Les réductions s'appliquent à de grandes marques comme Colruyt, Zalando, Decathlon, Samsung, Booking.com, Bol.com, Ikea et bien plus encore.`,
                    img: "/images/fr_new_home/avantage-image/img_2_avantage.png",
                },
                {
                    categorie: "CONSEILS JURIDIQUES",

                    name: "CONSEILS JURIDIQUES",
                    title: `Assistance juridique : 80% de litiges résolus`,
                    description: `Un conflit avec une entreprise ? Introduisez une plainte via notre plateforme.  La signature de Testachats donne du poids à votre réclamation et accélère la réaction de l’enseigne de 4 jours en moyenne.  Et si cela ne suffit pas, 100 avocats sont à votre disposition pour vous aider à faire valoir vos droits. `,
                    img: "/images/fr_new_home/avantage-image/img_3_avantage.png",
                },
                {
                    categorie: "avantage énergie",

                    name: "avantage énergie",
                    title: `Trouvez les meilleurs fournisseurs d'énergie <span class="hide-mobile"> au meilleur prix, et ainsi faire le bon choix ? </span> `,
                    description: `Les contrats et les conditions des fournisseurs d'énergie sont parfois incompréhensibles. En tant que membre de Testachats, vous  recevez tous nos conseils juridiques, les connaissances et l’expérience de nos spécialistes</strong> pour vos démarches auprès des fournisseurs.`,
                    img: "/images/fr_new_home/avantage-image/img_4_avantage.png",
                },
                {
                    categorie: "tests d’EXPERTS",

                    name: "Tests d’experts",
                    title: `Des choix sûrs et personnalisés`,
                    description: `Changer de fournisseur d’énergie, acheter un lave-linge ou choisir votre mutuelle ? <br>
 Nos sélecteurs vous guident vers le produit le mieux adapté à vos priorités.</strong>  Une question spécifique ? Isolation, primes énergie, antivirus, déclaration fiscale... Appelez-nous ! Nos spécialistes vous répondront personnellement.`,
                    img: "/images/fr_new_home/avantage-image/img_6_avantage.png",
                },
            ]
        },
        selectedGiftId: sync('form_data/gift'),
    },
    mounted() {
        for (let i = 0; i < document.querySelectorAll('a[href^="#"]').length; i++) {
            document.querySelectorAll('a[href^="#"]')[i].addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector(document.querySelectorAll('a[href^="#"]')[i].getAttribute('href')).scrollIntoView({
                    behavior: 'smooth'
                });
            });
        }
    }
};
</script>
